// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal.car-selector .vs__dropdown-toggle{min-width:284px}input::-moz-placeholder{color:#a9a9a9!important;opacity:1}input::placeholder{color:#a9a9a9!important;opacity:1}input::-webkit-input-placeholder{color:#a9a9a9}input::-moz-placeholder{color:#a9a9a9}input:-ms-input-placeholder{color:#a9a9a9}input:-moz-placeholder{color:#a9a9a9}", ""]);
// Exports
module.exports = exports;
